module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ba5e2227458079ef42609e9cc01ef0f9.gif";